export default {
  namespaced: true,
  state: {
    token: null,
    userInfo: null,
    userState: null
  },
  getters: {
    userInfo (state) {
      return state.userInfo
    },
    userState (state) {
      return state.userState
    },
    token (state) {
      return `Bearer ${state.token}`
    }
  },
  mutations: {
    setToken (state, data) {
      state.token = data
      localStorage.setItem('token', data)
    },
    setUserInfo (state, data) {
      state.userInfo = data
    },
    setUserState (state, data) {
      state.userState = data
    }
  },
  actions: {
    logout (context, payload) {
      localStorage.removeItem('token')
      context.commit('setToken', null)
      context.commit('setUserInfo', null)
      context.dispatch('layout/updateProfile', {
        name: null,
        role: 'USER',
        email: null
      }, { root: true })
    },
    login (context, payload) {
      const promise = this.server.login(payload)
      return promise
    },
    sendOtp (context, payload) {
      const promise = this.server.otp(payload)
      promise.then((response) => {
        if (response && response.data) {
          context.commit('setToken', response.data)
          context.dispatch('self')
        }
      })
      return promise
    },
    state (context) {
      const promise = this.server.state()
      promise.then((response) => {
        context.commit('setUserState', response.data)
      })
      return promise
    },
    self (context) {
      const promise = this.server.self()
      promise.then((response) => {
        context.commit('setUserInfo', response.data)
        context.dispatch('layout/updateProfile', {
          name: response.data.name,
          role: 'USER',
          email: response.data.phone
        }, { root: true })
      })
      return promise
    }
  }
}
